// Sdílená konfigurace renderování menu (hustota, resolver ikon, akce). Drill-down sloupce
// (ColumnsView) si drží vlastní lokální stav, ale tuto neměnnou konfiguraci berou
// z kontextu, aby se neprotahovala přes každý prop.

import { createContext, useContext } from 'react';

import type { DensityTokens } from './density';
import type { MenuDensity, MenuIconResolver, MenuItemNode, MenuSepStyle } from './menuTypes';

export interface MenuConfig {
  readonly density: MenuDensity;
  readonly densityTokens: DensityTokens;
  readonly separators: MenuSepStyle;
  readonly detachAlways: boolean;
  readonly iconForNode: MenuIconResolver;
  readonly onOpen: (node: MenuItemNode) => void;
  readonly onDetach: (node: MenuItemNode) => void;
}

export const MenuConfigContext = createContext<MenuConfig | null>(null);

export function useMenuConfig(): MenuConfig {
  const ctx = useContext(MenuConfigContext);
  if (!ctx) throw new Error('useMenuConfig must be used within <MenuConfigContext.Provider>');
  return ctx;
}
